import { render, staticRenderFns } from "./Afastamentos.vue?vue&type=template&id=0edf1942&"
import script from "./Afastamentos.vue?vue&type=script&lang=js&"
export * from "./Afastamentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports